module.exports = __webpack_public_path__ + "images/Wallet3.a3a692d09735aec8136db3100af432fa.svg";